<script setup lang="ts">
import { useRoute } from 'vue-router/composables';
import { computed } from 'vue';
import { TagDto } from '@/api';
import { getProviderIconSrc } from '@/utils/provider-icons';
import SEllipsisToolTip from '@/components/SEllipsisTooltip/SEllipsisTooltip.vue';
import SIcon from '@/components/SIcon.vue';

interface TagProps {
  tag: TagDto;
  showTooltip?: boolean;
  filter?: boolean;
}
const props = defineProps({
  tag: null,
  showTooltip: { type: Boolean, default: false },
  filter: { type: Boolean, default: false }
});

const route = useRoute();

const isClassification = computed(() => 'type' in props.tag && props.tag.type === TagDto.type.VISIBLE_DATA_CLASSIFICATION);
// Inherited external source/catalog tags are exactly the ones suffixed `_EXTERNAL`
const isInherited = computed(() => 'type' in props.tag && props.tag.type.endsWith('_EXTERNAL'));
const image = computed(() => {
  if ('type' in props.tag) {
    const providerKey = props.tag.type.replace(/_EXTERNAL$/, '');
    return getProviderIconSrc(`${providerKey}_LOCK`);
  }
  return '';
});
const isAssetOverview = computed(() => ['data-catalog.asset.overview', 'data-catalog.asset.lineage'].includes((route.name as string)));

</script>

<template lang="pug">
v-chip.tag.d-inline-flex.mr-1(
  v-bind="$attrs"
  v-on="$listeners"
  :class="{ 'assetOverview': isAssetOverview }"
  outlined
  small)
  SIcon.mr-1( color="iconNeutral" v-if="isClassification" icon="icon-star-circle-fill" size="small" )
  SIcon.mr-1( color="iconNeutral" v-if="isInherited" :icon="image" :alt="tag.name" size="small" )
  SEllipsisToolTip.grey--text.font-weight-medium(:content="tag.name")
</template>

<style lang="scss">

.theme--light {
  .v-chip.v-chip--outlined.tag {
    border-color: map-deep-get($grey, "lighten-3") !important;
    background-color: var(--v-bgTertiary-base) !important;
  }
}

.assetOverview {
  margin-bottom: 8px;
  margin-right: 8px;
}
</style>
